const COLORES_PREDEFINIDOS = [
  '#9900ff', 
  '#007FFF', 
  '#0FFF00', 
  '#ff7b00', 
  '#ff0000',
]

export {
  COLORES_PREDEFINIDOS
}
